import React,{useState,useRef} from 'react';
import { Box,useMediaQuery} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";



// import TextField from '@mui/material/TextField';
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import {  Button, Modal, Backdrop, Fade, TextField} from '@mui/material';
const initializeOtpInputRefs = () => {
  return Array.from({ length: 6 }, () => useRef(null));


};


const apiUrl = process.env.REACT_APP_API_REST_URL;








const Verify = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const navigate = useNavigate();
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState('');
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const otpInputRefs = initializeOtpInputRefs();

  const handleCloseModal = () => {
    setOtpModalOpen(false);
  };

  const handleCancel = () => {
    navigate("/");
  };


  const { state } = useLocation();
  const userId = state?.userId;
  const userEmail = state?.userEmail;
  const userPhone= state?.userPhone;
  const userStatus = state?.userVerificationStatus
  console.log("usreid0",userId);
  console.log("useremail",userEmail);
  console.log("useremail",userPhone);
  console.log("userverificationStatus",userStatus)

  const handleChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    const otpString = otp.join('');
    console.log("otp",otpString);
    if (index < 5 && value !== "") {
      otpInputRefs[index + 1].current.focus();
    }
    // console.log("phone",phone);
  };


  const handleemail = async () =>{
    try{
      const res = await axios.post(`${apiUrl}/CCE/api/v1/commonEngine/sendVerificationMail`,{
        candidate_id:userId,
        candidate_type:"user",
        email:userEmail,
        code:"Aaaaaaaaa"
      })
      if(res){
        toast.success("Verification mail sent successfully!");
      }
      console.log(res);

    }catch(error){
      console.error("Error:", error.message);
      toast.error("Failed to resend otp. Please try again.");
    }
    
  };
  const handlephone = async () =>{
    // const phoneAsNumber = parseInt(phone, 10);
    try{
      const res = await axios.post(`${apiUrl}/CCE/api/v1/commonEngine/reSendOtp`,{
        "candidate_id":userId,
        "candidate_type":"user",
        phone:userPhone

      });
      if(res){
        toast.success("Otp resent to your registered mobile number successfully!");
        setOtpModalOpen(true);
      }
      console.log("reswa of resendwa",res);
    }catch(error){
      console.error("Error:", error.message);
      toast.error("Failed to resend otp. Please try again.");
    }


  };

  const handleOtpVerification = async () => {
    const otpAsNumber = parseInt(otp.join(''), 10);
    // const phoneAsNumber = parseInt(phone, 10);


    try{
      const res = await axios.post(`${apiUrl}/CCE/api/v1/commonEngine/mobile_verify`,{
        phone: userPhone, // Access phone value from data object
        otp: otpAsNumber,
      });
      console.log("response",res);
      if(res.data.response.message==="Otp Verified"){
        setVerificationMessage("Great news! Your phone number has been successfully verified, and your account is now fully activated.Thank you for completing the phone verification process.");
        setOtp(["", "", "", "", "", ""]);
        // setTimeout(() => {
        //   // navigate("/agreement", { state: { userId } });
        // }, 2000); 
        // toast.success("Otp verified successfully!");
      }else if(res.data.response.message==="Incorrect otp"){
        // toast.error("Otp not verified successfully!");
        setVerificationMessage("We regret to inform you that the One-Time Password (OTP) entered for phone verification is not valid. Please ensure that you have entered the correct OTP provided in the SMS sent on your phone.");
        setOtp(["", "", "", "", "", ""]);
        // toast.error("Otp not verified successfully!");
      };
    


    }catch(error){
      console.error("Error:", error.message);
      toast.error("Network error. Please try again.");


    }
  };

  const handlehome = () => {
    window.open('https://www.investek.in/', '_blank');
  };

  

 

  return (
    <>
    {isSmallScreen ?(<span><Box>
      {userStatus === "PARTNER_PENDING" && (
      <Box sx={styles.formboxnewresmsg}>
         <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
          <h2>Information</h2>

        <div style={{textAlign:"left,",color:"black"}}>
        <div>
        Your registration details are under review. You will receive an email once it is approved. If you have received an email and are still not able to log in, then please contact support at   +91 124 668 7770 or email 
   {" "}<a href="mailto:Partnership@InvesTek.in" style={{ color: "blue", textDecoration: "none" }}>
 partnership@InvesTek.in"
  </a> {" "}   
</div>
        <div style={{textAlign:"center",margin:"10px"}}><Button
      sx={styles.btn}
        onClick={handlehome}
      >
        Ok
      </Button></div>
      </div>
        
      </Box>
      
      )}
       {userStatus === "PARTNER_REJECTED" && (
      <Box sx={styles.formboxnewresmsg}>
         <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
          <h2>Information</h2>

        <div style={{textAlign:"left,",color:"black"}}>
        <div>
        Your request for the Partnership program has been rejected by our team. If you want to appeal, please contact support at +91 124 668 7770 or email  {" "}<a href="mailto:Partnership@InvesTek.in" style={{ color: "blue", textDecoration: "none" }}>
    Partnership@InvesTek.in
  </a>{" "}</div>
        <div style={{textAlign:"center",margin:"10px"}}><Button
      sx={styles.btn}
        onClick={handlehome}
      >
        Ok
      </Button></div>
      </div>

        
      </Box>
      
      )}
    {userStatus === "EMAIL_NOT_VERIFIED" && (
      <Box sx={styles.formboxnewres}>
         <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
          <h3>Sign Up Approval</h3>

        <div style={{textAlign:"left,",color:"black"}}>
        <div> Your registration details are under review. You will receive an email once it is approved.  If you have received an email and are still not able to log in, then please contact the support at +91 124 668 7770 or email  {" "}<a href="mailto:Partnership@InvesTek.in" style={{ color: "blue", textDecoration: "none" }}>
    Partnership@InvesTek.in
  </a>{" "}</div>
        <div style={{textAlign:"center",margin:"10px"}}><Button
      sx={styles.btn}
        onClick={handlehome}
      >
        Ok
      </Button></div>
      </div>
        
      </Box>
      
      )}

      {userStatus === "MOBILE_NOT_VERIFIED" && (
        <Box sx={styles.formboxnewres}>
           <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
             <h3>Phone Verification</h3>
          <div style={{textAlign:"left,",color:"black"}}>
        <div>It appears that the phone verification process for your account has not been completed. <br />

To fully activate your account and access our services, please enter the OTP sent to your phone entered during your registration.</div>
       <div style={{textAlign:"center,",margin:"10px"}}>
       <Button
     sx={styles.btn}
       onClick={handlephone}
     >
       Verify phone
     </Button>
         </div>
     </div></Box>
        
      )}
      {userStatus === "EMAIL_AND_MOBILE_NOT_VERIFIED" && (
        <Box sx={styles.formboxres}>
           <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
             <h3>Email & Phone Verification</h3>
          <div>
          <div style={{textAlign:"left,",color:"black"}}>
          <div>It appears that the email verification and phone verification process for your account has not been completed.<br></br>

To fully activate your account and access our services, please follow the verification link provided in the email sent to you and OTP sent on mobile.</div>
          <div style={{textAlign:"center",margin:"10px"}}><Button
          sx={styles.btn}
            onClick={handleemail}
          >
            Verify email
          </Button>
          <Button
          sx={styles.btn}
            onClick={handlephone}
          >
            Verify phone
          </Button>
          </div>
          </div>
        </div>

        </Box>
        
      )}

    <Box sx={{ marginTop: '10px' }}>
      <Modal
        open={otpModalOpen}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={otpModalOpen}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', padding: '15px', background: '#FFFFFF', borderRadius: '8px', textAlign: 'center', height: '400px', width: '300px' }}>
            <h2>Ent OTP</h2>
            {otp.map((digit, index) => (
            <TextField
              key={index}
              type="text"
              variant="outlined"
              size="small"
              inputProps={{ maxLength: 1 }}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              style={{ width: '2.5em', marginRight: '0.5em' }}
              inputRef={otpInputRefs[index]} // Associate ref with the OTP input
            />
          ))}
            <Button sx={styles.verifybtn} type="button" variant="contained" onClick={handleOtpVerification}>
              Verify OTP
            </Button>

            {verificationMessage && (
        <div style={{ marginTop: '10px', color: verificationMessage.includes('successfully') ? 'green' : 'red' }}>
          {verificationMessage}
        </div>
      )}
         <div
      onClick={handlephone}
      style={{
        color: 'blue',            // Set the text color
        textDecoration: 'underline', // Add an underline to mimic a link
        cursor: 'pointer',
        marginTop:"5px"        // Change the cursor to a hand pointer on hover
      }}
    >
      Resend OTP
    </div>

          </Box>
        </Fade>
      </Modal>
    </Box>
    
    </Box></span>):(<span><Box>
      {userStatus === "PARTNER_PENDING" && (
      <Box sx={styles.formboxmsg}>
         <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
          <h2>Information</h2>

        <div style={{textAlign:"left,",color:"black"}}>
        <div>
        Your registration details are under review. You will receive an email once it is approved. If you have received an email and are still not able to log in, then please contact support at   +91 124 668 7770 or email
  {" "}<a href="mailto:Partnership@InvesTek.in" style={{ color: "blue", textDecoration: "none" }}>
 partnership@InvesTek.in
  </a>{" "}
</div>

        <div style={{textAlign:"center",margin:"10px"}}><Button
      sx={styles.btn}
        onClick={handlehome}
      >
        Ok
      </Button></div>
      </div>
        
      </Box>
      
      )}
      {userStatus === "PARTNER_REJECTED" && (
      <Box sx={styles.formboxmsg}>
         <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
          <h2>Information</h2>

        <div style={{textAlign:"left,",color:"black"}}>
        <div> Your request for the Partnership program has been rejected by our team. If you want to appeal, please contact support at +91 124 668 7770 or email  {" "}<a href="mailto:Partnership@InvesTek.in" style={{ color: "blue", textDecoration: "none" }}>
        {" "}<a href="mailto:Partnership@InvesTek.in" style={{ color: "blue", textDecoration: "none" }}>
    Partnership@InvesTek.in
  </a>{" "}
  </a>{" "}</div>
        <div style={{textAlign:"center",margin:"10px"}}><Button
      sx={styles.btn}
        onClick={handlehome}
      >
        Ok
      </Button></div>
      </div>

        
      </Box>
      
      )}
    {userStatus === "EMAIL_NOT_VERIFIED" && (
      <Box sx={styles.formboxnew}>
         <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
          <h2>Sign Up Approval</h2>

        <div style={{textAlign:"left,",color:"black"}}>
        <div> Your registration details are under review. You will receive an email once it is approved.  If you have received an email and are still not able to log in, then please contact the support at +91 124 668 7770 or email  {" "}<a href="mailto:Partnership@InvesTek.in" style={{ color: "blue", textDecoration: "none" }}>
    Partnership@InvesTek.in
  </a>{" "}</div>
        <div style={{textAlign:"center",margin:"10px"}}><Button
      sx={styles.btn}
        onClick={handlehome}
      >
        Ok
      </Button></div>
      </div>
        
      </Box>
      
      )}

      {userStatus === "MOBILE_NOT_VERIFIED" && (
        <Box sx={styles.formboxnew}>
           <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
             <h2>Phone Verification</h2>
          <div style={{textAlign:"left,",color:"black"}}>
        <div>It appears that the phone verification process for your account has not been completed. <br />

To fully activate your account and access our services, please enter the OTP sent to your phone entered during your registration.</div>
       <div style={{textAlign:"center,",margin:"10px"}}>
       <Button
     sx={styles.btn}
       onClick={handlephone}
     >
       Verify phone
     </Button>
         </div>
     </div></Box>
        
      )}
      {userStatus === "EMAIL_AND_MOBILE_NOT_VERIFIED" && (
        <Box sx={styles.formboxnew}>
           <Box
          onClick={handleCancel}
          sx={{
            textAlign: "right",
            cursor: "pointer",
            color: "#666666",
          }}
        >
          <CloseIcon />
        </Box>
             <h2>Email & Phone Verification</h2>
          <div>
          <div style={{textAlign:"left,",color:"black"}}>
          <div>It appears that the email verification and phone verification process for your account has not been completed.<br></br>

To fully activate your account and access our services, please follow the verification link provided in the email sent to you and OTP sent on mobile.</div>
          <div style={{textAlign:"center",margin:"10px"}}><Button
          sx={styles.btn}
            onClick={handleemail}
          >
            Verify email
          </Button>
          <Button
          sx={styles.btn}
            onClick={handlephone}
          >
            Verify phone
          </Button>
          </div>
          </div>
        </div>

        </Box>
        
      )}

    <Box sx={{ marginTop: '10px' }}>
      <Modal
        open={otpModalOpen}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={otpModalOpen}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', padding: '15px', background: '#FFFFFF', borderRadius: '8px', textAlign: 'center', height: '400px', width: '300px' }}>
            <h2>Enter OTP</h2>
            {otp.map((digit, index) => (
            <TextField
              key={index}
              type="text"
              variant="outlined"
              size="small"
              inputProps={{ maxLength: 1 }}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              style={{ width: '2.5em', marginRight: '0.5em' }}
              inputRef={otpInputRefs[index]} // Associate ref with the OTP input
            />
          ))}
            <Button sx={styles.verifybtn} type="button" variant="contained" onClick={handleOtpVerification}>
              Verify OTP
            </Button>

            {verificationMessage && (
        <div style={{ marginTop: '10px', color: verificationMessage.includes('successfully') ? 'green' : 'red' }}>
          {verificationMessage}
        </div>
      )}
         <div
      onClick={handlephone}
      style={{
        color: 'blue',            // Set the text color
        textDecoration: 'underline', // Add an underline to mimic a link
        cursor: 'pointer',
        marginTop:"5px"        // Change the cursor to a hand pointer on hover
      }}
    >
      Resend OTP
    </div>

          </Box>
        </Fade>
      </Modal>
    </Box>
    
    </Box></span>)}
    </>
    
  );
};

export default Verify;

const styles = {
    formbox: {
      position: "absolute",
      top: "40%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "15px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "300px",
      width: "520px",
      overflow: "auto",
  
      scrollbarWidth: "thin",
      scrollbarColor: "#d9d9d9 #fff",
      "&::-webkit-scrollbar": {
        width: "2px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#d9d9d9",
      },
    },
    formboxres: {
      position: "absolute",
      top: "40%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "15px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "300px",
      width: "320px",
      overflow: "auto",
  
      scrollbarWidth: "thin",
      scrollbarColor: "#d9d9d9 #fff",
      "&::-webkit-scrollbar": {
        width: "2px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#d9d9d9",
      },
    },
    formboxnew: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "15px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "300px",
      width: "520px",
      overflow: "auto",
  
      scrollbarWidth: "thin",
      scrollbarColor: "#d9d9d9 #fff",
      "&::-webkit-scrollbar": {
        width: "2px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#d9d9d9",
      },
    },
    formboxmsg: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "15px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "300px",
      width: "520px",
      overflow: "auto",
  
      scrollbarWidth: "thin",
      scrollbarColor: "#d9d9d9 #fff",
      "&::-webkit-scrollbar": {
        width: "2px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#d9d9d9",
      },
    },
    formboxnewres: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "15px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "300px",
      width: "320px",
      overflow: "auto",
  
      scrollbarWidth: "thin",
      scrollbarColor: "#d9d9d9 #fff",
      "&::-webkit-scrollbar": {
        width: "2px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#d9d9d9",
      },
    },
    formboxnewresmsg: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "15px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "300px",
      width: "320px",
      overflow: "auto",
  
      scrollbarWidth: "thin",
      scrollbarColor: "#d9d9d9 #fff",
      "&::-webkit-scrollbar": {
        width: "2px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#d9d9d9",
      },
    },
    btn: {
      margin: "1em 0em 0em 2em",
      width: "5em",
      backgroundColor: "#002C51",
      color: "white",
      textTransform: "none",
      "&:hover": {
        background: "#002C51",
      },
    },
    verifybtn: {
      width: "150px",
      height: "40px",
      marginTop: "1em",
      backgroundColor: "#002C51",
      color: "white",
      textTransform: "none",
      "&:hover": {
        background: "#002C51",
      },
  
    }
  };
  
